export default defineNuxtRouteMiddleware(async (to) => {
  const auth = useAuthStore()

  // if we have a token but no real user yet, go fetch it
  if (auth.logged && !auth.user.name) {
    await auth.fetchUser()
  }

  const locale       = auth.user.preferred_language || 'en'
  const completePath = locale === 'en'
    ? '/auth/complete-registration'
    : `/${locale}/auth/complete-registration`

  if (
    auth.logged &&
    auth.user.account_status === 'incomplete' &&
    to.path !== completePath
  ) {
    return navigateTo(completePath)
  }
})
